import { render, staticRenderFns } from "./TreatmentCard.vue?vue&type=template&id=2dde7582&scoped=true"
import script from "./TreatmentCard.vue?vue&type=script&lang=js"
export * from "./TreatmentCard.vue?vue&type=script&lang=js"
import style0 from "./TreatmentCard.vue?vue&type=style&index=0&id=2dde7582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dde7582",
  null
  
)

export default component.exports